import Vue from 'vue';
import Vuex from 'vuex';

import size from './modules/size'
import toolMsg from './modules/toolMsg'
import search from './modules/search'
import shortcut from './modules/shortcut'
import style from './modules/style'
import works from './modules/works'
import topnav from './modules/topnav'
import soundRecord from './modules/soundRecord'
import voiceAI from './modules/voiceAI'
import user from './modules/user'
import lang from './modules/lang'
import hands from './modules/hands'
import camera from './modules/camera'
import games from './modules/games'
import templateMaterialLib from './modules/templateMaterialLib'
import fontList from './modules/fontList'
import wbCooperation from './modules/cooperation'
import versionControl from './modules/versionControl'
import draftVersion from './modules/draftVersion'
import draftBackup from './modules/draftBackup'
import cooperationBackup from './modules/cooperationBackup'
import subtitle from './modules/subtitle'
import subtitleExport from './modules/subtitleExport'
import tracking from './modules/tracking'
import templates from './modules/templates'
import smartVoice from './modules/smartVoice'
import addSoundtrack from './modules/addSoundtrack'
import soundtrackSet from './modules/soundtrackSet'
import materialArea from './modules/materialArea';
import resources from './modules/resources'
import textContent from './modules/resourcesArea/textContent'
import characterContent from './modules/resourcesArea/characterContent'
import musicContent from './modules/resourcesArea/musicContent'
import sourceMaterial from './modules/resourcesArea/sourceMaterial'
import userTask from './modules/userTask'
import vipPaying from './modules/vipPaying';
import helpCenter from './modules/helpCenter';
import previewInit from './modules/draftPreview/init';
import previewTool from './modules/draftPreview/tool';
import previewControls from './modules/draftPreview/controls';
import IPRolePay from './modules/IPRolePay';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    size,
    toolMsg,
    search,
    shortcut,
    style,
    works,
    topnav,
    soundRecord,
    voiceAI,
    user,
    lang,
    hands,
    camera,
    games,
    templateMaterialLib,
    fontList,
    wbCooperation,
    versionControl,
    draftVersion,
    draftBackup,
    cooperationBackup,
    subtitle,
    subtitleExport,
    tracking,
    templates,
    addSoundtrack,
    soundtrackSet,
    smartVoice,
    materialArea,
    resources,
    textContent,
    characterContent,
    musicContent,
    sourceMaterial,
    userTask,
    vipPaying,
    helpCenter,
    previewInit,
    previewTool,
    previewControls,
    IPRolePay
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js